import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dismiss() {
    this.element.style.display = "none"
  }

  verify() {
    // Track PostHog event for import banner verification
    App.analytics.posthog_capture("leads-import-banner-verify-performed", {})

    this.dismiss()
  }
}
